
import React, { useEffect, useState } from "react";
import './SlidingAlert.scss';

export default function SlidingAlert({
    message = "Alert message",
    type = "info", // 'info' | 'success' | 'warning' | 'error'
    duration = 10000,
    onClose = () => { },
    visible = true,
    sub = ""
}) {
    const [isVisible, setIsVisible] = useState(visible);
    const [exiting, setExiting] = useState(false);

    useEffect(() => {
        if (!isVisible) return;
        if (duration > 0) {
            const timer = setTimeout(() => handleClose(), duration);
            return () => clearTimeout(timer);
        }
    }, [isVisible]);

    const handleClose = () => {
        setExiting(true);
        setTimeout(() => {
            setIsVisible(false);
            onClose();
        }, 200);
    };

    if (!isVisible) return null;

    return (
        <div className="sl-alert-container">
            <div className={`sl-alert ${type} ${exiting ? "exiting" : ""}`}>
                <div className="sl-alert-hed">
                    {message}
                    <div className="sl-alert-close"
                        onClick={() => { handleClose() }}>X</div>
                </div>
                <div className="sl-alert-sub ">
                    {sub}
                </div>
            </div>
        </div>
    );
}
